// E:\new-react-project\the-ultimate-guide\src\Security\firebase-config.js

import { getApp, getApps, initializeApp } from "firebase/app";
import { getAuth } from "firebase/auth";
import { getFirestore } from "firebase/firestore";
import { getFunctions } from "firebase/functions";
import { getStorage } from "firebase/storage";
import { initializeAppCheck, ReCaptchaV3Provider } from "firebase/app-check";

// CRA replaces direct REACT_APP_* references at build time.
// Avoid dynamic process.env[key] access here because production bundles can
// otherwise end up with undefined Firebase config values on the live site.
const processEnv =
  typeof process !== "undefined" && process && process.env ? process.env : {};

const runtimeEnv = {
  REACT_APP_FIREBASE_API_KEY:
    processEnv.REACT_APP_FIREBASE_API_KEY || "AIzaSyD67QA3GdMVk6bJbC820PLxktHGCbfOaYc",
  REACT_APP_FIREBASE_AUTH_DOMAIN:
    processEnv.REACT_APP_FIREBASE_AUTH_DOMAIN || "theultimatesaladclanguide.firebaseapp.com",
  REACT_APP_FIREBASE_PROJECT_ID:
    processEnv.REACT_APP_FIREBASE_PROJECT_ID || "theultimatesaladclanguide",
  REACT_APP_FIREBASE_STORAGE_BUCKET:
    processEnv.REACT_APP_FIREBASE_STORAGE_BUCKET || "theultimatesaladclanguide.firebasestorage.app",
  REACT_APP_FIREBASE_MESSAGING_SENDER_ID:
    processEnv.REACT_APP_FIREBASE_MESSAGING_SENDER_ID || "907185590096",
  REACT_APP_FIREBASE_APP_ID:
    processEnv.REACT_APP_FIREBASE_APP_ID || "1:907185590096:web:b8a900ae3fd21c2fb2a655",
  REACT_APP_APPCHECK_DEBUG_TOKEN:
    processEnv.REACT_APP_APPCHECK_DEBUG_TOKEN || "",
  REACT_APP_RECAPTCHA_SITE_KEY:
    processEnv.REACT_APP_RECAPTCHA_SITE_KEY || "6Lc5gokrAAAAANPTS8EApVhPTuSLzBPONcaPKdMY",
};
const readEnv = (key) => runtimeEnv[key];

// ─────────────────────────────────────────────────────────────
// Firebase config (from .env)
// ─────────────────────────────────────────────────────────────
const firebaseConfig = {
  apiKey: readEnv("REACT_APP_FIREBASE_API_KEY"),
  authDomain: readEnv("REACT_APP_FIREBASE_AUTH_DOMAIN"),
  projectId: readEnv("REACT_APP_FIREBASE_PROJECT_ID"),
  storageBucket: readEnv("REACT_APP_FIREBASE_STORAGE_BUCKET"),
  messagingSenderId: readEnv("REACT_APP_FIREBASE_MESSAGING_SENDER_ID"),
  appId: readEnv("REACT_APP_FIREBASE_APP_ID"),
};

console.log("[Firebase] Auth Domain:", firebaseConfig.authDomain);

// ─────────────────────────────────────────────────────────────
// Initialize Firebase
// ─────────────────────────────────────────────────────────────
const app = getApps().length ? getApp() : initializeApp(firebaseConfig);

export const auth = getAuth(app);
export const db = getFirestore(app);
export const functions = getFunctions(app, "us-central1");
export const storage = getStorage(app);

// ─────────────────────────────────────────────────────────────
// App Check
// ─────────────────────────────────────────────────────────────
const isLocalhost =
  typeof window !== "undefined" &&
  (window.location.hostname === "localhost" ||
    window.location.hostname === "127.0.0.1");

if (isLocalhost) {
  console.log("[AppCheck] Skipped on localhost to avoid dev blocking.");
} else {
  try {
    // Only enable debug token if explicitly provided
    const appCheckDebugToken = readEnv("REACT_APP_APPCHECK_DEBUG_TOKEN");
    const recaptchaSiteKey = readEnv("REACT_APP_RECAPTCHA_SITE_KEY");

    if (appCheckDebugToken) {
      window.FIREBASE_APPCHECK_DEBUG_TOKEN =
        appCheckDebugToken;
    }

    if (!recaptchaSiteKey) {
      console.warn("[AppCheck] Skipped because no reCAPTCHA site key was found.");
    } else {
      initializeAppCheck(app, {
        provider: new ReCaptchaV3Provider(recaptchaSiteKey),
        isTokenAutoRefreshEnabled: true,
      });

      console.log("[AppCheck] Initialized.");
    }
  } catch (err) {
    console.error("[AppCheck] Initialization failed:", err);
  }
}

export default app;
